var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imgBox",staticStyle:{"overflow":"hidden"}},[_c('img',{ref:"img",attrs:{"src":_vm.src}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }